var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-confirm-dialog'),_c('router-view'),_c('phone-dial-modal'),_c('FloatingPhoneButton'),_c('IncomingCallsAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }